<template>
  <div id="homepageQuickLinks" class="interaction-bar-component">
    <div id="interactionBar" class="interaction-bar scroll-parent" data-has-scrollbar="true" :data-brand="getBrand" data-scroll-region="min">
      <div class="scroll-horizontal">
        <div class="scroll-item scroll-item--default" data-item="New Vehicles">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="New Vehicles">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.55 41.32"><g id="Layer_1-2"><path d="m43.06,20.53h-2l-5.16-11.6c-.48-1.07-1.54-1.76-2.71-1.76H11.36c-1.17,0-2.24.69-2.71,1.76l-5.16,11.6H1.48c-.82,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48h1.48v14.85c0,1.64,1.33,2.97,2.97,2.97h4.45c1.64,0,2.97-1.33,2.97-2.97v-2.97h17.82v2.97c0,1.64,1.33,2.97,2.97,2.97h4.45c1.64,0,2.97-1.33,2.97-2.97v-14.85h1.48c.82,0,1.48-.66,1.48-1.48s-.66-1.48-1.48-1.48ZM11.36,10.14h21.83l4.62,10.39H6.74l4.62-10.39Zm27.25,28.21h-4.45v-4.45c0-.82-.66-1.48-1.48-1.48H11.88c-.82,0-1.48.66-1.48,1.48v4.45h-4.45v-14.85h32.67v14.85Z"/><path d="m42.53,3.87c-.08-.23-.26-.41-.49-.49l-2.08-.75-.76-2.08c-.16-.43-.64-.65-1.07-.49-.23.08-.41.26-.49.49l-.75,2.07-2.08.76c-.43.16-.65.64-.49,1.07.08.23.26.41.49.49l2.07.75.76,2.08c.12.34.44.54.78.54.1,0,.19-.02.29-.05.23-.08.41-.26.49-.49l.75-2.07,2.08-.76c.43-.16.65-.64.49-1.07Zm-3.07.82c-.23.09-.41.27-.5.5l-.54,1.47-.53-1.47c-.08-.23-.27-.41-.5-.5l-1.47-.53,1.47-.53c.23-.09.41-.27.5-.5l.54-1.47.54,1.47c.09.23.27.41.5.5l1.47.53-1.47.54h0Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">New Vehicles</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Used Vehicles">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Used Vehicles">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.55 34.15"><g id="Layer_1-2"><path d="m43.06,13.36h-2l-5.16-11.6C35.43.69,34.36,0,33.19,0H11.36c-1.17,0-2.24.69-2.71,1.76L3.49,13.36H1.48c-.82,0-1.48.66-1.48,1.48s.66,1.48,1.48,1.48h1.48v14.85c0,1.64,1.33,2.97,2.97,2.97h4.45c1.64,0,2.97-1.33,2.97-2.97v-2.97h17.82v2.97c0,1.64,1.33,2.97,2.97,2.97h4.45c1.64,0,2.97-1.33,2.97-2.97v-14.85h1.48c.82,0,1.48-.66,1.48-1.48s-.66-1.48-1.48-1.48ZM11.36,2.97h21.83l4.62,10.39H6.74L11.36,2.97Zm27.25,28.21h-4.45v-4.45c0-.82-.66-1.48-1.48-1.48H11.88c-.82,0-1.48.66-1.48,1.48v4.45h-4.45v-14.85h32.67v14.85Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Pre-Owned Vehicles</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Schedule Service">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Schedule Service">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.97 36.63"><g id="Layer_1-2"><path d="m31.72,29.34l-5.04-5.04c.36-1.64.19-3.36-.48-4.9-1.76-4.01-6.44-5.84-10.45-4.08l-1.64.72,5.07,5.08h0c.48.48.47,1.25,0,1.73-.48.46-1.24.46-1.73,0l-5.07-5.07-.72,1.64c-.68,1.54-.85,3.26-.48,4.9.94,4.28,5.18,6.98,9.46,6.04l5.04,5.04c.8.8,1.89,1.25,3.02,1.25,1.13,0,2.22-.45,3.02-1.25,1.67-1.67,1.67-4.38,0-6.04Zm-1.73,4.32c-.72.69-1.86.69-2.59,0l-6.07-6.07-.71.23c-.55.18-1.12.27-1.7.27-3.03,0-5.49-2.46-5.49-5.5,0-.1,0-.2,0-.31l2.29,2.29c1.45,1.38,3.73,1.38,5.18,0,1.43-1.43,1.43-3.75,0-5.18l-2.29-2.29c.1,0,.2,0,.31,0,.58,0,1.15.09,1.7.27,2.88.94,4.46,4.04,3.52,6.92l-.23.71,6.07,6.07s0,0,0,0c.71.72.71,1.87,0,2.59Z"/><path d="m2.44,6.11h3.66v3.66h14.65v-3.66h3.66v6.11h2.44v-6.11c0-1.35-1.1-2.44-2.44-2.44h-3.66v-1.22c0-1.35-1.1-2.44-2.44-2.44h-9.77c-1.35,0-2.44,1.1-2.44,2.44v1.22h-3.66c-1.35,0-2.44,1.1-2.44,2.44v25.64c0,1.35,1.1,2.44,2.44,2.44h8.55v-2.44H2.44V6.11Zm6.11-3.66h9.77v4.88h-9.77V2.44Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Schedule Service</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Value Your Trade">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Value Your Trade">
            <span class="quick-link-btn__icon"><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.2 37.97"><g id="Layer_1-2"><path d="m24.81,3.89h-2.62c-.65-2.24-2.7-3.89-5.15-3.89h-3.89c-2.45,0-4.49,1.65-5.15,3.89h-2.62C2.41,3.89,0,6.3,0,9.27v23.31c0,2.97,2.41,5.39,5.39,5.39h19.43c2.97,0,5.39-2.41,5.39-5.39V9.27c0-2.97-2.41-5.39-5.39-5.39Zm-11.66-.89h3.77c1.11,0,2.17.71,2.43,1.79.39,1.57-.8,2.98-2.31,2.98h-3.77c-1.11,0-2.17-.71-2.43-1.79-.39-1.57.8-2.98,2.31-2.98Zm14.04,29.58c0,1.32-1.07,2.39-2.39,2.39H5.39c-1.32,0-2.39-1.07-2.39-2.39V9.27c0-1.32,1.07-2.39,2.39-2.39h2.62c.65,2.24,2.7,3.89,5.15,3.89h3.89c2.45,0,4.49-1.65,5.15-3.89h2.62c1.32,0,2.39,1.07,2.39,2.39v23.31Z"/><path d="m14.13,18.54h4.86c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-2.39v-.44c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5v.47c-2.53.3-4.41,2.75-3.76,5.47.48,2,2.38,3.33,4.43,3.33h1.8c.78,0,1.41.63,1.41,1.41s-.63,1.41-1.41,1.41h-4.86c-.83,0-1.5.67-1.5,1.5s.67,1.5,1.5,1.5h2.39v.44c0,.83.67,1.5,1.5,1.5s1.5-.67,1.5-1.5v-.47c2.53-.3,4.41-2.75,3.76-5.47-.48-2-2.38-3.33-4.43-3.33h-1.8c-.78,0-1.41-.63-1.41-1.41s.63-1.41,1.41-1.41Z"/></g></svg></span>
            <span class="quick-link-btn__label">Value Your Trade</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Search Inventory">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Search Inventory">
            <span class="quick-link-btn__icon"><svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.16 27.37"><g id="Layer_1-2"><path d="m34.66,27.37H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h33.16c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Zm0-6.38c-.38,0-.77-.15-1.06-.44l-4.5-4.5c-.08-.08-.15-.17-.21-.26-1.42,1.01-3.16,1.6-5.03,1.6-4.8,0-8.7-3.9-8.7-8.7S19.07,0,23.86,0s8.7,3.9,8.7,8.7c0,1.87-.59,3.61-1.6,5.03.09.06.18.13.26.21l4.5,4.5c.59.59.59,1.54,0,2.12-.29.29-.68.44-1.06.44ZM23.86,3c-3.14,0-5.7,2.56-5.7,5.7s2.56,5.7,5.7,5.7,5.7-2.56,5.7-5.7-2.56-5.7-5.7-5.7Zm-14.07,13.5H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.29c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Zm0-10.01H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.29c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"/></g></svg></span>
            <span class="quick-link-btn__label">Search</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Cars Under $50K">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Cars Under $50K">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.2 36.05"><g id="Layer_1-2"><path d="m9.64,21.13c.41,0,.7.21,1.03.75.57,1.01,1.55,1.56,2.82,1.56,1.68,0,2.75-.9,2.75-2.32s-1.1-2.35-2.74-2.35h-1.13c-.56,0-.96-.41-.96-.97s.39-.94.96-.94h1.07c1.38,0,2.37-.9,2.37-2.16s-.98-2.12-2.4-2.12c-1.11,0-1.95.55-2.44,1.52-.27.54-.57.76-1.03.76-.58,0-.98-.41-.98-1.01,0-1.62,1.88-3.14,4.49-3.14s4.63,1.53,4.63,3.7c0,1.53-1.15,2.96-2.57,3.19v.14c1.72.17,3.02,1.66,3.02,3.44,0,2.42-2.1,4.13-5.09,4.13-2.71,0-4.76-1.58-4.76-3.22,0-.56.39-.98.95-.98Z"/><path d="m20.32,17.73c0-4.22,1.92-7.01,5.19-7.01s5.17,2.76,5.17,7.01v.6c0,4.22-1.94,7-5.2,7s-5.16-2.75-5.16-7v-.6Zm2.33.57c0,3.16,1.08,5.08,2.85,5.08s2.85-1.91,2.85-5.08v-.56c0-3.17-1.09-5.09-2.86-5.09s-2.84,1.92-2.84,5.09v.56Z"/><path d="m33.07,24.58c-.43,0-.67-.27-.67-.74v-7.23c0-.47.24-.74.66-.74s.66.27.66.74v4.2h.07l2.35-2.4c.22-.22.39-.31.59-.31.32,0,.56.23.56.56,0,.18-.07.34-.25.52l-1.72,1.74,1.93,2.48c.16.19.23.38.23.55,0,.33-.28.61-.61.61-.22,0-.41-.11-.6-.35l-1.95-2.5-.62.59v1.56c0,.47-.24.74-.66.74Z"/><rect class="cls-1" x="1.5" y="1.5" width="43.2" height="33.05" rx="3.25" ry="3.25" style="fill:none;stroke:var(--primary-color);stroke-miterlimit:10;stroke-width:3px;"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Cars Under $30K</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="All Electric">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="All Electric">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.61 38.72"><g id="Layer_1-2"><path d="m28.2,17.8c-.1-.41-.39-.75-.79-.9l-9.12-3.42,2.32-11.61c.13-.69-.31-1.35-1-1.48-.43-.08-.87.06-1.17.38L.72,19.77c-.48.51-.46,1.31.05,1.79.12.12.27.21.43.27l9.12,3.42-2.31,11.59c-.13.69.31,1.35,1,1.48.43.08.87-.06,1.17-.38l17.73-18.99c.29-.31.4-.74.31-1.15h0Zm-16.84,15.17l1.66-8.29c.12-.61-.21-1.21-.79-1.43l-8.36-3.14,13.39-14.35-1.66,8.29c-.12.61.21,1.21.79,1.43l8.36,3.13-13.39,14.36Z"/><path d="m9.25,38.72c-.11,0-.21,0-.32-.03-.43-.08-.8-.33-1.05-.69-.24-.36-.33-.8-.25-1.23l2.25-11.28-8.82-3.31c-.21-.08-.39-.2-.55-.35-.66-.62-.68-1.66-.06-2.32L18.17.52c.39-.42.96-.6,1.51-.49.43.08.8.33,1.05.69.25.36.33.8.25,1.23l-2.26,11.29,8.82,3.31c.51.19.9.62,1.03,1.16h0c.12.54-.03,1.09-.4,1.49l-17.73,18.99c-.31.34-.75.52-1.19.52ZM19.37.75c-.24,0-.48.1-.65.28L1,20.02c-.17.17-.25.4-.25.64,0,.24.11.46.28.62.09.08.19.15.3.19l9.42,3.53-2.38,11.91c-.05.23,0,.47.14.67.13.2.33.33.57.38.31.06.61-.04.82-.26l17.72-18.99c.2-.22.28-.52.22-.81-.07-.29-.28-.53-.56-.63l-9.42-3.53,2.38-11.92c.05-.23,0-.47-.14-.67s-.33-.33-.57-.38c-.06-.01-.12-.02-.17-.02Zm-8.64,33.44l1.92-9.58c.09-.43-.15-.85-.56-1.01l-8.88-3.34,14.67-15.72-1.91,9.58c-.09.43.15.85.56,1.01l8.88,3.33-14.67,15.73Zm-6.21-14.24l7.84,2.95c.75.29,1.19,1.07,1.03,1.86l-1.4,6.99,12.1-12.98-7.83-2.94c-.76-.29-1.19-1.07-1.03-1.86l1.4-7-12.11,12.97Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">All Electric</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="View Specials">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="View Specials">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.19 38.74"><g id="Layer_1-2"><path d="m37.19,3.1v11.38c0,17.36-14.69,23.12-17.63,24.1-.63.21-1.31.21-1.94,0C14.68,37.61,0,31.85,0,14.49V3.1C0,1.39,1.39,0,3.1,0h30.99c1.71,0,3.1,1.39,3.1,3.1Zm-3.1,0H3.1v11.39c0,15.21,12.88,20.28,15.5,21.15,2.65-.88,15.5-5.96,15.5-21.15V3.1Z"/><path class="cls-1" d="m26.84,17.58l-5.15-1.87-1.87-5.16c-.25-.67-1-1.02-1.67-.77-.35.13-.63.41-.77.77l-1.87,5.15-5.16,1.87c-.67.25-1.02,1-.77,1.67.13.35.41.63.77.77l5.15,1.87,1.87,5.16c.25.67,1,1.02,1.67.77.35-.13.63-.41.77-.77l1.87-5.15,5.15-1.87c.67-.25,1.02-1,.77-1.67-.13-.35-.41-.63-.77-.77Zm-5.6,3.08c-.36.13-.64.41-.77.77l-1.87,5.14-1.87-5.14c-.13-.36-.42-.65-.78-.78l-5.14-1.87,5.14-1.87c.36-.13.65-.42.78-.78l1.87-5.14,1.87,5.14c.13.36.41.64.77.77l5.14,1.87-5.14,1.87Z" style="stroke:var(--primary-color);stroke-miterlimit:10;stroke-width:1.1px;"/></g></svg>
            </span>
            <span class="quick-link-btn__label">View Specials</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Model Research">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Model Research">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.07 35.23"><g id="Layer_1-2"><path d="m47.73,14.29l-3.49-3.49c-.06-.06-.13-.12-.21-.16.78-1.1,1.24-2.45,1.24-3.9,0-3.72-3.02-6.74-6.74-6.74s-6.74,3.02-6.74,6.74,3.02,6.74,6.74,6.74c1.45,0,2.8-.46,3.9-1.24.05.07.1.14.16.21l3.49,3.49c.23.23.52.34.82.34s.6-.11.82-.34c.45-.45.45-1.19,0-1.64Zm-9.19-3.13c-2.44,0-4.42-1.98-4.42-4.42s1.98-4.42,4.42-4.42,4.42,1.98,4.42,4.42-1.98,4.42-4.42,4.42Z"/><path d="m39.07,18.3l-9.29-3.99c-.16-.07-.3-.19-.39-.34l-3.48-5.95-.11-.17c-.54-.68-1.36-1.07-2.22-1.07h-11.41c-.96,0-1.85.47-2.38,1.27l-4.59,6.92c-.15.23-.42.37-.69.37h-2.23c-1.25,0-2.26,1.01-2.26,2.26v11.17c0,1.25,1.01,2.26,2.26,2.26h1.64c.35,0,.64.23.77.56,1.04,2.7,3.97,4.23,6.82,3.45,1.76-.48,3.17-1.76,3.82-3.44.13-.34.43-.57.79-.57h7.77c.35,0,.64.23.77.56,1.04,2.7,3.97,4.23,6.82,3.45,1.76-.48,3.17-1.76,3.82-3.44.13-.34.43-.57.79-.57h1.62c1.25,0,2.26-1.01,2.26-2.26v-9.15c0-.57-.34-1.09-.87-1.31Zm-15.23-8.26l3.09,5.3h-11.89v-5.71h8.07c.3,0,.57.16.72.41Zm-11.9-.04c.08-.12.18-.21.31-.27v5.61h-3.87l3.57-5.34Zm-1.95,22.45c-1.58,0-2.85-1.28-2.85-2.85s1.28-2.85,2.85-2.85,2.85,1.28,2.85,2.85-1.28,2.85-2.85,2.85Zm19.97,0c-1.58,0-2.85-1.28-2.85-2.85s1.28-2.85,2.85-2.85,2.85,1.28,2.85,2.85-1.28,2.85-2.85,2.85Zm7.13-5.11c0,.46-.37.83-.83.83h-.21c-.35,0-.64-.23-.77-.56-1.04-2.7-3.97-4.23-6.82-3.45-1.76.48-3.17,1.76-3.82,3.44-.13.34-.43.57-.79.57h-7.77c-.35,0-.64-.23-.77-.56-1.04-2.7-3.97-4.23-6.82-3.45-1.76.48-3.17,1.76-3.82,3.44-.13.34-.43.57-.79.57h-.19c-.46,0-.83-.37-.83-.83v-8.32c0-.46.37-.83.83-.83h2.02c.12,0,.24-.02.36-.05h25.29s.07,0,.1-.01l5.13,2.21c.31.13.5.43.5.77v6.24Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Model Research</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Financing">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Financing">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.68 34.01"><g id="Layer_1-2"><path d="m1.42,25.51h36.85c.78,0,1.42.63,1.42,1.42h0c0,.78-.63,1.42-1.42,1.42H1.42c-.78,0-1.42-.63-1.42-1.42h0c0-.78.63-1.42,1.42-1.42Zm0,5.67h36.85c.78,0,1.42.63,1.42,1.42h0c0,.78-.63,1.42-1.42,1.42H1.42c-.78,0-1.42-.63-1.42-1.42h0c0-.78.63-1.42,1.42-1.42ZM31.18,8.5c-1.57,0-2.83,1.27-2.83,2.83s1.27,2.83,2.83,2.83,2.83-1.27,2.83-2.83-1.27-2.83-2.83-2.83Zm-11.34,8.5c-3.13,0-5.67-2.54-5.67-5.67s2.54-5.67,5.67-5.67,5.67,2.54,5.67,5.67c0,3.13-2.54,5.67-5.67,5.67Zm0-8.5c-1.57,0-2.83,1.27-2.83,2.83s1.27,2.83,2.83,2.83,2.83-1.27,2.83-2.83c0-1.56-1.27-2.83-2.83-2.83Zm-11.34,0c-1.57,0-2.83,1.27-2.83,2.83s1.27,2.83,2.83,2.83,2.83-1.27,2.83-2.83-1.27-2.83-2.83-2.83Z"/><path d="m36.85,22.68H2.83c-1.56,0-2.83-1.27-2.83-2.83V2.83C0,1.27,1.27,0,2.83,0h34.01c1.56,0,2.83,1.27,2.83,2.83v17.01c0,1.56-1.27,2.83-2.83,2.83Zm0-19.84H2.83v17.01h34.01V2.83Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Financing</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Directions">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Directions">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.61 35.61"><g id="Layer_1-2"><path class="cls-1" d="m12.37,30.49l-9.44,3.15c-.57.19-1.19-.12-1.38-.69-.04-.11-.06-.23-.06-.35V5.91c0-.47.3-.88.74-1.03L12.37,1.5m0,28.99l10.87,3.62m-10.87-3.62V1.5m10.87,32.61l10.13-3.37c.44-.15.74-.56.74-1.03V3.01c0-.6-.49-1.09-1.09-1.09-.12,0-.23.02-.34.06l-9.44,3.15m0,28.99V5.12m0,0L12.37,1.5" style="fill:none;stroke:var(--primary-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Directions</span>
          </a>
        </div>
        <div class="scroll-item scroll-item--default" data-item="Contact Us">
          <a href="#" class="quick-link-btn quick-link-btn--default event-click track-click" data-category="Homepage Quick Link" data-action="Contact Us">
            <span class="quick-link-btn__icon">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.46 39.46"><g id="Layer_1-2"><path d="m27.31,6.07c0-.84.68-1.52,1.52-1.52h3.04V1.52C31.86.68,32.54,0,33.38,0s1.52.68,1.52,1.52v3.04h3.04c.84,0,1.52.68,1.52,1.52s-.68,1.52-1.52,1.52h-3.04v3.04c0,.84-.68,1.52-1.52,1.52s-1.52-.68-1.52-1.52v-3.04h-3.04c-.84,0-1.52-.68-1.52-1.52Zm11.88,10.38c1.81,10.74-5.44,20.92-16.18,22.73C12.26,40.99,2.08,33.74.28,23-1.53,12.26,5.71,2.08,16.46.27c2.17-.36,4.38-.36,6.55,0,.83.15,1.38.93,1.23,1.76-.14.82-.91,1.36-1.73,1.24C13.4,1.74,4.77,7.88,3.24,16.98c-.15.91-.23,1.84-.23,2.76,0,4.09,1.5,8.04,4.22,11.09,1.69-2.45,4.08-4.35,6.85-5.46-3.95-3.11-4.63-8.84-1.52-12.8,3.11-3.95,8.84-4.63,12.8-1.52,3.95,3.11,4.63,8.84,1.52,12.8-.44.56-.96,1.08-1.52,1.52,2.77,1.1,5.15,3,6.85,5.46,2.72-3.05,4.23-7,4.22-11.09,0-.93-.08-1.87-.23-2.79-.15-.83.41-1.61,1.23-1.76.83-.15,1.61.41,1.76,1.23,0,0,0,.02,0,.03Zm-19.47,7.84c3.35,0,6.07-2.72,6.07-6.07s-2.72-6.07-6.07-6.07-6.07,2.72-6.07,6.07,2.72,6.07,6.07,6.07Zm0,12.15c3.71,0,7.31-1.23,10.24-3.51-3.61-5.65-11.13-7.31-16.78-3.69-1.48.95-2.74,2.21-3.69,3.69,2.92,2.28,6.53,3.52,10.24,3.51Z"/></g></svg>
            </span>
            <span class="quick-link-btn__label">Contact Us</span>
          </a>
        </div>
      </div>
      <div class="scroll-overlay scroll-overlay--left"></div>
      <div class="scroll-overlay scroll-overlay--right"></div>
      <div class="scroll-nav scroll-nav--left">
        <button
          type="button"
          class="scroll-nav-btn"
          data-scroll-parent="#interactionBar"
          data-direction="left"
          tabindex="0"
        ></button>
      </div>
      <div class="scroll-nav scroll-nav--right">
        <button
          type="button"
          class="scroll-nav-btn"
          data-scroll-parent="#interactionBar"
          data-direction="right"
          tabindex="0"
        ></button>
      </div>
    </div>
  </div>
</template>

<!-- jQuery (v2) -->
<script scroped src="//ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js"></script>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    getBrand () {
      return this.brand;
    }
  },
  mounted() {
    (function($){
    const scrollElements = {
      init: function() {

        scrollElements.scrollNavInit();

        $('#homepageQuickLinks .scroll-parent').each(function(){
          
          let parent = '#' + $(this).attr('id');
          let element = parent + ' .scroll-horizontal';
          
          scrollElements.setDataRegion(parent, element);
          scrollElements.setDataHasScrollbar(parent, element);

          $(window).resize(function(){
            scrollElements.setDataHasScrollbar(parent, element);
          })
          
          $(element).on('scroll', function(){
            scrollElements.setDataRegion(parent, element);
          })

        })

        $('#homepageQuickLinks [data-toggle="tab"]').click(function(){
          setTimeout(function(){
            $('#homepageQuickLinks .tab-content .scroll-parent').each(function(){
              let parent = '#' + $(this).attr('id');
              let element = parent + ' .scroll-horizontal';
              scrollElements.setDataHasScrollbar(parent, element);
            });
          }, 220);
        });

      }, 

      scrollNavInit: function() {
        
        $('#homepageQuickLinks .scroll-parent .scroll-nav').click(function(){

          $(this).find('.scroll-nav-btn').focus();
          
          let scrollParent = $(this).find('.scroll-nav-btn').attr('data-scroll-parent');
          let scrollTarget = scrollParent + ' .scroll-horizontal';
          let scrollContent = scrollTarget + ' > *';
          let distance = 0;

          $(scrollContent).each(function(){
            if ($(this).outerWidth() > distance) {
              distance = $(this).outerWidth();
            }
          })
          
          let currentPosition = scrollElements.getPosition(scrollTarget);

          if ($(this).find('.scroll-nav-btn').attr('data-direction') === 'right') {
            scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition + distance);
          } else {
            scrollElements.animateScroll(scrollParent, scrollTarget, distance, currentPosition - distance);
          }
          
        })
      },

      setDuration: function(distance) {
        return Math.floor(distance / 0.7);
      }, 

      animateScroll: function(parent, element, distance, newPosition) {
        
        $(element).animate({
            scrollLeft: newPosition
        }, scrollElements.setDuration(distance));

        setTimeout(function(){
          scrollElements.setDataRegion(parent, element);
        }, scrollElements.setDuration(distance));
        
      }, 

      getPosition: function(element) {
        return $(element).scrollLeft();
      }, 

      getMaxScroll: function(element) {
        return document.querySelector(element).scrollWidth - (document.querySelector(element).clientWidth + 10);
      }, 

      setDataRegion: function(parent, element) {
        let maxScroll = scrollElements.getMaxScroll(element);
        let currentPosition = scrollElements.getPosition(element);

        if (currentPosition === 0 && maxScroll < 0) {
          $(parent).attr('data-scroll-region', 'min');
        } else if (currentPosition >= maxScroll) {
          $(parent).attr('data-scroll-region', 'max');
        } else if (currentPosition === 0) {
          $(parent).attr('data-scroll-region', 'min');
        } else {
          $(parent).attr('data-scroll-region', 'middle');
        }
      }, 

      setDataHasScrollbar: function(parent, element) {
        if (scrollElements.getPosition(element) === 0 && scrollElements.getMaxScroll(element) <= 0) {
          $(parent).attr('data-has-scrollbar', 'false');
        } else {
          $(parent).attr('data-has-scrollbar', 'true');
        }
      }
    }

    $(document).ready(scrollElements.init);

  })(jQuery)
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  
  /* Component Classes */
  .interaction-bar-component .scroll-parent {
    position: relative;
    width: 100%;
    margin: 0 auto;
  }
  .interaction-bar-component .scroll-horizontal {
    position: relative;
    background-color: #ffffff;
    overflow-x: scroll;
    width: 100%;
    margin: 0 auto;
    white-space: nowrap;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .interaction-bar-component .scroll-horizontal::-webkit-scrollbar {
    display: none;
  }
  .interaction-bar-component .scroll-horizontal > * {
    display: inline-block;
    white-space: normal;
    vertical-align: text-top;
  }
  .interaction-bar-component .scroll-overlay, 
  .interaction-bar-component .scroll-nav {
    width: 15%;
    height: 100%;
    position: absolute;
    top: 0;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  .interaction-bar-component .scroll-overlay--left {
    left: 0;
    background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, 5%, #ffffff 100%);
  }
  .interaction-bar-component .scroll-overlay--right {
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, 5%,#ffffff 100%);
  }
  .interaction-bar-component .scroll-nav {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .interaction-bar-component .scroll-nav--right {
    right: 0;
    align-items: flex-end;
    padding-right: 3%;
  }
  .interaction-bar-component .scroll-nav--left {
    left: 0;
    align-items: flex-start;
    padding-left: 3%;
  }
  .interaction-bar-component .scroll-nav-btn {
    font-size: inherit;
    font-weight: 300;
    width: 30px;
    height: 30px;
    color: #ffffff;
    background-color: transparent;
    border: solid 2px #000000;
    border-radius: 100%;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    background-image: url("../../static/images/common-icons/right-arrow-black.png");
    background-size: 35%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .interaction-bar-component .scroll-nav--left .scroll-nav-btn {
    transform: rotateY(180deg);
  }
  .interaction-bar-component .scroll-nav-btn:hover {
    opacity: 0.7;
  }
  .interaction-bar-component .scroll-nav-btn:focus,
  .interaction-bar-component .scroll-nav-btn:active {
    color: #101010;
    border-color: #101010;
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
  .interaction-bar-component .scroll-nav--left .scroll-nav-btn:focus, 
  .interaction-bar-component .scroll-nav--left .scroll-nav-btn:active {
    -webkit-transform: rotateY(180deg) scale(1.5);
    transform: rotateY(180deg) scale(1.5);
  }
  .interaction-bar-component .scroll-parent[data-scroll-region="min"] .scroll-overlay--left,
  .interaction-bar-component .scroll-parent[data-scroll-region="max"] .scroll-overlay--right,
  .interaction-bar-component .scroll-parent[data-scroll-region="min"] .scroll-nav--left,
  .interaction-bar-component .scroll-parent[data-scroll-region="max"] .scroll-nav--right,
  .interaction-bar-component .scroll-parent[data-has-scrollbar="false"] .scroll-overlay,
  .interaction-bar-component .scroll-parent[data-has-scrollbar="false"] .scroll-nav {
    opacity: 0;
    visibility: hidden;
  }
  @media (max-width: 767px) {
    .interaction-bar-component .scroll-parent {
      width: 90vw;
    }
    .interaction-bar-component .scroll-nav--right {
      right: -3%;
    }
    .interaction-bar-component .scroll-nav--left {
      left: -3%;
    }
    .interaction-bar-component .scroll-nav-btn:hover,
    .interaction-bar-component .scroll-nav-btn:active,
    .interaction-bar-component .scroll-nav-btn:focus {
      opacity: 1;
      color: #101010;
      border-color: #101010;
      -webkit-transform: scale(1.3);
      transform: scale(1.3);
    }
    .interaction-bar-component .scroll-nav--left .scroll-nav-btn:hover,
    .interaction-bar-component .scroll-nav--left .scroll-nav-btn:active,
    .interaction-bar-component .scroll-nav--left .scroll-nav-btn:focus {
      -webkit-transform: rotateY(180deg) scale(1.3);
      transform: rotateY(180deg) scale(1.3);
    }
  }

  /* Kia */

  #homepageQuickLinks:not([data-brand="toyota"]) .scroll-nav-btn {
    border: none;
  }

  /* Quicklink Styles */

  #interactionBar[data-has-scrollbar="false"] .scroll-horizontal {
    text-align: center;
    justify-content: center;
  }

  #homepageQuickLinks .scroll-horizontal {
    padding: 30px 0;
  }

  .quick-link-btn {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 1.4vw;
    color: var(--primary-dark);
    text-shadow: 0 0 var(--primary-dark);
    font-size: 12px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  .quick-link-btn:hover, 
  .quick-link-btn:active, 
  .quick-link-btn:focus {
    outline: none;
    text-decoration: none;
    color: var(--primary-dark);
    opacity: 0.3;
  }
  .quick-link-btn__icon {
    display: inline-block;
    width: 23px;
    height: 23px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin-bottom: 10px;
  }
  .quick-link-btn__icon svg {
    display: inline-block;
    width: 100%;
    height: 100%;
    fill: #000000;
    fill: var(--primary-color);
  }
  .interaction-bar-component .scroll-item[data-item="Model Research"] .quick-link-btn__icon {
    width: 33px;
    height: 23px;
  }

  #interactionBar[data-brand="infiniti"] .quick-link-btn__icon svg {
    fill: var(--primary-dark);
  }
  #interactionBar[data-brand="infiniti"] .quick-link-btn__icon svg .cls-1 {
    stroke: var(--primary-dark) !important;
  }

  /* Brand-Specific Styles 
  
  #homepageQuickLinks[data-brand="chevrolet"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="ford"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="honda"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="hyundai"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="infiniti"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="kia"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="lincoln"] .quick-link-btn__icon,
  #homepageQuickLinks[data-brand="mazda"] .quick-link-btn__icon {
    filter: grayscale(1);
  }
  */

  @media (max-width: 1199px) {
    #homepageQuickLinks .scroll-horizontal {
      padding: 15px 0;
    }
  }

  @media (max-width: 767px) {
    #homepageQuickLinks {
      width: 100vw;
    }

    #homepageQuickLinks .scroll-horizontal {
      padding: 10px 0;
    }

    #homepageQuickLinks .quick-link-btn {
      min-width: 90px;
      font-size: 10px;
    }
  }

</style>
